// THPRT-6298: some in-app WebView / embedded browser runtimes do not expose the
// FileReader global. Instantiating `new FileReader()` unguarded threw an uncaught
// ReferenceError on the document-upload paths (Sentry PORTAL-20-87), blocking ID
// verification for affected clients. This helper guards availability and rejects
// cleanly, so callers surface a user-facing error instead of crashing.

export const isFileReaderAvailable = (): boolean => typeof FileReader !== 'undefined'

export const readFileAsDataURL = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        if (!isFileReaderAvailable()) {
            reject(new Error('FILEREADER_UNAVAILABLE'))
            return
        }
        const reader = new FileReader()
        reader.onload = e => resolve(e.target?.result as string)
        reader.onerror = () => reject(reader.error ?? new Error('FILE_READ_FAILED'))
        reader.readAsDataURL(file)
    })
